import React, { useState } from 'react';
import { Link2, Check } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Input } from '@/components/ui/input';

// options: [{ id, label, group }]
export const DependsOnPicker = ({ options, value, onChange, testId = 'depends-on-picker' }) => {
  const [q, setQ] = useState('');
  const toggle = (id) => onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);
  const filtered = options.filter(o => o.label.toLowerCase().includes(q.toLowerCase()));
  const groups = [...new Set(filtered.map(o => o.group))];

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="w-36 shrink-0 inline-flex items-center justify-center gap-1.5 text-xs px-2.5 py-1.5 rounded-md border border-stone-200 bg-white text-stone-700 hover:border-amber-700 transition-colors">
          <Link2 className="w-3.5 h-3.5" />
          {value.length ? `Finish first: ${value.length}` : 'Must finish first…'}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-2 bg-white" align="start">
        <Input placeholder="Search tasks" value={q} onChange={e => setQ(e.target.value)} className="h-8 text-xs mb-2" data-testid={`${testId}-search`} />
        <div className="max-h-64 overflow-y-auto space-y-2">
          {groups.length === 0 && <p className="text-xs text-stone-500 p-2">No other tasks yet.</p>}
          {groups.map(g => (
            <div key={g}>
              <p className="text-[10px] uppercase tracking-wider text-stone-400 px-1 mb-1">{g}</p>
              {filtered.filter(o => o.group === g).map(o => (
                <button type="button" key={o.id} onClick={() => toggle(o.id)} data-testid={`${testId}-option-${o.id}`}
                  className="w-full flex items-center gap-2 text-left text-xs px-2 py-1.5 rounded hover:bg-stone-50">
                  <span className={`w-4 h-4 rounded border flex items-center justify-center ${value.includes(o.id) ? 'bg-amber-700 border-amber-700' : 'border-stone-300'}`}>
                    {value.includes(o.id) && <Check className="w-3 h-3 text-white" />}
                  </span>
                  <span className="flex-1 text-stone-700">{o.label}</span>
                </button>
              ))}
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
